import { h, Component } from 'preact';
import style from './style'
import dayjs from 'lib/helpers/dayjs';
import {TimeSlotColumn} from 'components/groups'
import {Row, Col, Container, SquareImage, Button, I18n} from 'components/elements'
import {times} from 'lib/helpers'
import {WaitListActions} from 'actions'
import {FAChevronDown, FAChevronUp, FASpinner} from 'components/elements/FontAwesome'
const Fragment = Component.Fragment;

export default class TimeSlotsCard extends Component {
	constructor(){
        super()
        this.state = {
			expanded: false
		}
		this.handleShowMore = this.handleShowMore.bind(this)
		this.destroyFromWaitlist = this.destroyFromWaitlist.bind(this)
		this.addToWaitlists = this.addToWaitlists.bind(this)
	}

	componentWillReceiveProps(nextProps){
		if(!nextProps.startDate.isSame(this.props.startDate)){
			this.setState({expanded: false})
		}
	}

	componentDidMount(){
		this.fetch()
	}

	get appointmentType(){
		return this.props.appointmentTypes[this.props.filters.appointmentTypeID] || {}
	}

	get hasRestrictions(){
		return (this.appointmentType.rules || []).length > 0
	}

	get moreTimeSlots(){
		return this.timeSlotsData.moreTimeSlots
	}

	get hasTimeSlots(){
		for(let data of this.timeSlotsData.timeSlots){
			if(data.length){
				return true
			}
		}
		return false
	}
	
	get timeSlots(){
		return this.timeSlotsData.timeSlots
	}

	get timeSlotsData(){
		let moreTimeSlots = false
		let timeSlots = times(2).map((i)=>{
			let filterDate = this.props.startDate.clone().add(i,"days").format("MM/DD/YYYY")
			let timeSlots = this.props.timeSlots.filter((ts)=> {
				return dayjs(ts.startsAt).format("MM/DD/YYYY") == filterDate
			}).sort((a,b)=>{
				if(dayjs(a.startsAt).isBefore(dayjs(b.startsAt))) return -1
				if(dayjs(a.startsAt).isAfter(dayjs(b.startsAt))) return 1
				return 0
			})
			
			if(timeSlots.length > 4){
				moreTimeSlots = true
				if(!this.state.expanded){
					timeSlots = timeSlots.slice(0,4)
				}
			}
	
			return timeSlots
		})

		return {timeSlots, moreTimeSlots}
	}
	
	get hasMoreAvailabilites(){
		if(this.props.outOfSlots || dayjs(this.props.startDate).isAfter(dayjs().add(6,"months"))){
			return false
		}
		return true
	}

	get showAddToQueue(){
		if(this.waitlistItem){
			return true
		}
		return false
	}

    get account(){
        return this.props.session.account
    }

    get waitListActivated(){
        return _.get(this, 'props.organization.settings.waitList')
    }

	addToWaitlists(){
		let accountID = this.account.id
        let appointmentTypeID = this.appointmentType.id
		return WaitListActions.create({
			administratorID: this.props.id,
			accountID,
			appointmentTypeID
		}).then(()=>{
			this.fetch()
		})
	}

	get waitlistItem(){
		return Object.values(this.props.waitLists || []).filter((_waitList)=>
            _waitList.appointmentTypeID == this.appointmentType.id
            && _waitList.administratorID == this.props.id
        )[0]
	}

	fetch() {
		let accountID = this.account.id
		let appointmentTypeID = this.appointmentType.id
		return WaitListActions.fetch({
			accountID,
			appointmentTypeID
		})
	}

	destroyFromWaitlist(id){
		return WaitListActions.destroy({id})
		.then((res)=>{
			this.fetch()
		})
	}

	get name(){
		return this.props.name || `${this.props.firstName || ''} ${this.props.lastName || ''}`
	}

	handleShowMore(){
		this.setState({
			expanded: !this.state.expanded
		})
	}
    

	render() {
		return (
			<Container>
				<div class={style.select}>
					<Row>
						{!this.props.condensedAdministrators &&
							<Col span={{sm: 24, md:8}} noPaddingTop>
								<Row>
									{this.props.image && (
										<Col span={{sm: 12}}>
											<SquareImage 
												image={this.props.image}
												minWidth="100px"
												maxWidth="200px" />
										</Col>
									)}
									<Col span={{sm: this.props.image ? 12 : 24}}>
										<div class={style.descriptionContainer}>
											<label class={style.cardName}>
												{this.name}
											</label>
											<div>
												{this.props.description}
											</div>
										</div>
									</Col>
								</Row>
								<Row>
									<Col span={{sm: 24, md: 'hidden', lg: 'hidden'}}>
										<hr /> 
									</Col>
								</Row>
							</Col>
						}
						<Col span={{sm: 24, md: this.props.condensedAdministrators ? 24 : 16}}>
                            {this.waitListActivated && 
                                <Fragment>
                                    {this.showAddToQueue ? (
                                        <Row>
                                            <Col span={{sm: "hidden",md: 2}}></Col>
                                                <Col span={{sm: 24,md: 20}}>
                                                    <div class={style.nextAvailable} onClick={
                                                            this.destroyFromWaitlist.bind(null, this.waitlistItem.id)
                                                        }>
                                                        {
                                                            <I18n>destroyMyWaitlist</I18n>
                                                        }
                                                    </div>
                                                </Col>
                                            <Col span={{sm: "hidden",md: 2}}></Col>
                                        </Row>
                                    ):(
                                        <Row>
                                            <Col span={{sm: "hidden",md: 2}}></Col>
                                            <Col span={{sm: 24,md: 20}}>
                                                <div class={style.nextAvailable} onClick={
                                                        this.addToWaitlists
                                                    }>												
                                                        <I18n>addedToWaitlist</I18n> 
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </Fragment>
                            }
							<Fragment>
								{this.props.processing? (
									<div class={style.spinerOuter}>
                                        <FASpinner class={style.spinner} />
									</div>
								) :	(
									<Row class={[style.centered, style.appointmentsContainer]}>
										<Col span={{sm: "hidden",md: 2}}></Col>
											{this.timeSlots.map((timeSlots)=>{
												return (
													<Col span={{sm: 12,md: 10}}>
														<TimeSlotColumn
															isWidgetAvailableAfter={this.props.isWidgetAvailableAfter}
															timeSlots={timeSlots}
															onSelect={this.props.onSelect} 
															selectedTimeSlot={this.props.selectedTimeSlot}
														/>
													</Col>
												)
											})}
										<Col span={{sm: "hidden",md: 2}}></Col>
									</Row>
								)}
								<div class={style.morePromptSpacer}>
									{this.moreTimeSlots ?
										<div onClick={this.handleShowMore}>
											<Row class={style.centered}>
												{this.state.expanded? "Show Less":"Show More" }
											</Row>
											<Row class={style.centered}>
												{this.state.expanded?
                                                    <FAChevronUp />
												:
                                                    <FAChevronDown />
												}
											</Row>
										</div>
									: '' }
									{!this.hasRestrictions && !this.hasTimeSlots && !this.props.condensedAdministrators && !_.get(this, 'props.organization.integrations.datapoint.active') ?
										<Row>
											<Col span={{sm: "hidden",md: 2}}></Col>
												<Col span={{sm: 24,md: 20}}>
													<div class={style.nextAvailable} onClick={this.hasMoreAvailabilites ? this.props.handleSkipToNext:''}>
														{this.hasMoreAvailabilites ? <I18n>skipToAvailable</I18n> : <I18n>sorryNoFurtherAppointments</I18n>}
													</div>
												</Col>
											<Col span={{sm: "hidden",md: 2}}></Col>
										</Row>
									: '' }
								</div>
							</Fragment>
						</Col>
					</Row>
				</div>
			</Container>
		)
	}
}


// WEBPACK FOOTER //
// ./components/partials/TimeSlotsCard/index.js